<template>
  <div>
    <el-dialog :close-on-click-modal="false" title="新增" :visible.sync="visible" width="70%"
      :before-close="handleClose">
      <div>
        <el-form :model="form" :rules="rules" ref="roleForm" label-width="100px">
          <el-form-item label="标题" prop="title">
            <el-input v-model="form.title" placeholder="請輸入"></el-input>
          </el-form-item>
          <el-form-item label="单图" prop="image">
            <Upload ref="upload" @change="uploadChange" :limit="1"></Upload>
          </el-form-item>
          <el-form-item label="多图" prop="images">
            <Upload ref="uploads" @change="uploadChanges" :limit="5"></Upload>
          </el-form-item>
          <el-form-item label="内容" prop="text">
            <wangEditor @change="editChange" v-model="form.text"></wangEditor>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="submit">確 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import Upload from "@/components/upload/Upload"
  import wangEditor from "@/components/editor/wangEditor"
  export default {
    components: {
      Upload,
      wangEditor
    },
    props: {
      dialogVisible: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        visible:false,
        form: {
          title: '',
          image: '',
          images: '',
          sort: 0,
          text:'',
        },
        ruleList: [],
        rules: {
          title: [{
            required: true,
            message: "标题不能为空",
            trigger: "blur"
          }],
        },
      }
    },
    created() {},
    methods: {
      editChange(data) {
        this.form.text = data;
      },
      uploadChange(data) {
        this.form.image = data;
      },
      uploadChanges(data) {
        this.form.images = data; //数组转json
      },
      submit() {
        this.$refs.roleForm.validate((valid) => {
          if (valid) {
            this.$request({
              url: this.$api.test.create,
              method: "post",
              data: this.form
            }).then((res) => {
              if (res.data.code == 1) {
                this.$message.success(res.data.msg)
                this.form = {
                  title: '',
                  image: '',
                  images: '',
                  sort: 0,
                  text:'',
                }
                this.$refs.upload.clearFiles();
                this.$refs.uploads.clearFiles();
                this.form.text = ''
                this.$emit("ok");
                this.visible = false
              } else {
                this.$message.error(res.data.msg)
              }
            }).catch(() => {
              this.$message.error("请求失败");
            })
          } else {
            return false;
          }
        })
      },
      handleClose() {
        this.form = {
          title: '',
          image: '',
          images: '',
          sort: 0,
          text:'',
        };
        this.$refs.upload.clearFiles();
        this.$refs.uploads.clearFiles();
        this.visible =false
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/settings/test/createModal.vue